export default __webpack_public_path__ + "static/media/p56.3615a411.jpg";